export interface ResolveDatePickerValueFormatOptions {
  valueFormat?: string;
  format?: string;
  showTime?: boolean;
}

/**
 * 推导 DatePicker / RangePicker 落库格式。
 * 优先级：显式 valueFormat > format > showTime 兜底 datetime > 纯日期默认。
 */
export function resolveDatePickerValueFormat(
  opts: ResolveDatePickerValueFormatOptions,
): string {
  const explicit = opts.valueFormat?.trim();
  if (explicit) return explicit;

  const display = typeof opts.format === 'string' ? opts.format.trim() : '';
  if (display) return display;

  if (opts.showTime) return 'YYYY-MM-DD HH:mm:ss';

  return 'YYYY-MM-DD';
}
